/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterPharmacies } from '../types/FilterPharmacies'
import { defaultFormatTimeZone } from '../utils/consts'

interface PharmaciesFiltersContextType {
  filters: FilterPharmacies
  setFilters: (filters: FilterPharmacies) => any
}
const initialState: PharmaciesFiltersContextType = {
  filters: {
    orderStates: [],
    orderCities: [],
    createdAt: {
      initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-pharmacies-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const PharmaciesFiltersContext = createContext(initialState)

const PharmaciesFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <PharmaciesFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </PharmaciesFiltersContext.Provider>)
}

export default PharmaciesFiltersContextProvider
